 import { useEffect, useState } from "react";
import { useGlobalContext } from "src/context/useGlobalContext";

const MODAL_PATH = 'show-navigate-to-shopify-modal';

const NavigateToShopifyModal = () => {

    const { navigate, getQueryParameter } = useGlobalContext();

    const [show, SetShow] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const isShowModalInPath = getQueryParameter(MODAL_PATH);

    useEffect(() => {
        if(isShowModalInPath) setShowModal(true);
        else setTimeout(() => setShowModal(false), 200);

        // --eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowModalInPath])

    useEffect(() => {
        if (isShowModalInPath) setTimeout(() => SetShow(true), 100);
        else SetShow(false);
    }, [isShowModalInPath]);

	return showModal ? (
		<div
			className={`contact-me-modal ${show ? "show" : ""}`}
			data-type="modal"
		>
			<div className="container p-2 w-[80vw] lg:px-10 lg:py-5 lg:w-[400px]">
				<div className="w-full max-w-[1280px] pb-5 flex justify-center text-4xl">
					Development shopify store
				</div>
                <i>You will be prompted to enter the store password</i>
                <div className="flex  mt-2 mb-6">
                    <span className="mr-2">Store Password: </span><span className="bg-white text-black px-2 w-max">david</span>
                </div>
				<div className="w-full flex justify-end gap-6">
					<button
                        className="border-white border-b px-2"
						onClick={(e) => navigate(-1)}
					>
						Go back
					</button>
					<button
						className="bg-orange-500 py-1 rounded flex justify-center px-4"
					>
                        <a href="https://test-store-david-chavez.myshopify.com/" target="_blank">I understand</a>
					</button>
				</div>
			</div>
		</div>
	) : '';
};

export default NavigateToShopifyModal;